import { Component, QueryList, ViewChildren, ViewEncapsulation, OnInit } from '@angular/core';
import { FirmenService } from '@app/services/firmen.service';
import { FirmaDto } from '@app/dto/firma.dto';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { map, mergeMap, forkJoin, mergeAll, toArray } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { FirmenstandorteService } from '@app/services/firmenstandorte.service';
import { NewFirmenHauptstandortDto } from '@app/dto/newFirmenhauptstandort.dto';
import { PcAdressenService } from '@app/services/pcadressen.service';
import { action } from './action.model';
import { MatLegacyTable as MatTable, MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { PcAdresseUmhaengenDto } from '@app/dto/pcadresse.umhaengen.dto';
import { FirmenstandortDto } from '@app/dto/firmenstandort.dto';
import { TransactionDto } from '@app/dto/transaction.dto';
import { FirmenstandorteIndexResultElement } from '@app/dto/firmenstandorte.index.result-element.dto';
import { expandableRowAnimation } from "../firmen/expandable-row.animation";
import { PcAdresseNeuZuordnenComponent } from "@app/pc-adresse-neu-zuordnen/pc-adresse-neu-zuordnen.component";

declare var window: any;

interface PcAdresseElement {
  firmenId: number;
  firmenname: string;
  firmenstandortId: number;
  actions: action[]
  pcAdresseId: number;
  pcAdressnummer: number;
  nlCode: string;
  beDirectId: number;
  originalFirmenname: string;
  strasseUndHausnummer: string;
  plz: string;
  ort: string;
  laendercode: string;
  canBeMoved: boolean;
}

interface FirmenstandortElement {
  id?: number;
  firmenId?: number;
  firmenstandortId?: number;
  beDirectId?: number;
  istFirmenhauptstandort?: boolean;
  salesforceId?: string;
  strasseUndHausnummer?: string;
  plz?: string;
  ort?: string;
  laendercode?: string;
  telefon?: string;
  fax?: string;
  email?: string;
  betriebsgroesse?: string;
  betriebsgroesseGewerblich?: string;
  betriebsgroesseKaufmaennisch?: string;
  istGeloescht?: boolean;
  actions: action[];
  pcAdressen?: PcAdresseElement[];
  transactions?: TransactionDto[];
}

@Component({
  selector: 'app-firma',
  templateUrl: './firma.component.html',
  styleUrls: ['./firma.component.scss'],
  animations: [expandableRowAnimation],
  encapsulation: ViewEncapsulation.None
})
export class FirmaComponent implements OnInit {

  firmenElement?: FirmaDto;
  firmenStandorte: Array<FirmenstandortDto> = [];
  firmenId!: number;

  private urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  private numericPattern = '^[0-9]*$';

  public editFirmaDatenForm = new FormGroup({
    firmenname:           new FormControl('', [Validators.required]),
    branchenzuschlag:     new FormControl('kein Branchenzuschlag'),
    branchencodeWz1979:   new FormControl(''),
    branchencodeWz2008:   new FormControl(''),
    lieferantVonBranche:  new FormControl('0 - To be clarified'),
    waehrungscode:        new FormControl('EUR'),
    webseiteHomepage:     new FormControl('')
  });

  editFirmaDatenModal: any;

  public editStandortDatenForm = new FormGroup({
    strasseUndHausnummer:         new FormControl('', [Validators.required]),
    plz:                          new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("^[0-9]*$")]),
    ort:                          new FormControl('', [Validators.required]),
    laendercode:                  new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
    telefon:                      new FormControl(''),
    fax:                          new FormControl(''),
    email:                        new FormControl(''),
    betriebsgroesse:              new FormControl('ungeklärt'),
    betriebsgroesseGewerblich:    new FormControl('ungeklärt'),
    betriebsgroesseKaufmaennisch: new FormControl('ungeklärt'),
  });

  editStandortDatenModal: any;

  successModal: any;
  successMsg:   string = '';
  errorModal:   any;
  errorMsg:     string = '';

  displayedFirmaColumns: string[] = [
    'firmenname',
    'firmenId',
    'crefonummer',
    'action'
  ];

  displayedHauptstandortColumns: string[] = ['hauptstandort', 'actions']
  displayedFirmenstandortColumns: string[] = ['standort', 'actions']

  initColumns = [
    {
      name: 'pcAdressnummer',
      label: 'PcAdresse',
    },
    {
      name: 'nlCode',
      label: 'NlCode',
    },
    {
      name: 'firmenname',
      label: 'Name',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'laendercode',
      label: 'Land',
    },
  ];

  historyDisplayedColumns: string[] = [
    'datum',
    'uhrzeit',
    'transactionId',
    'aktion',
    'kommentar',
    'user'
  ];

  displayedPcAdresseColumns = this.initColumns.map(col => col.name);
  displayedPcAdresseColumnsWithActions: string[] = [...this.displayedPcAdresseColumns, 'actions'];

  tableFirmaDataSource: any;
  firmenstandortDataSource!: MatTableDataSource<FirmenstandortElement>;
  hauptstandortDataSource!: MatTableDataSource<FirmenstandortElement>;

  expandedElement!: FirmenstandortElement | null;
  expandedHauptstandortElement!: FirmenstandortElement | null;

  @ViewChildren('innerTables') innerTables = new QueryList<MatTable<PcAdresseElement>>();
  @ViewChildren('innerTableshauptstandort') innerTableshauptstandort = new QueryList<MatTable<PcAdresseElement>>();

  userInfo = this.msalService.instance.getAllAccounts()[0];
  userEmail = this.userInfo && this.userInfo.username ? this.userInfo.username : '';

  filterString: string;
  showAlsoDeletedElements: boolean = false;

  public currentStandortIsHauptstandort: boolean = false;
  public currentStandortId?: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private firmenService: FirmenService,
    private firmenstandorteService: FirmenstandorteService,
    private pcAdressenService: PcAdressenService,
    public  dialogNeuePcAdresse: MatDialog,
    private msalService: MsalService,
    private _snackBar: MatSnackBar,
  ) {

    this.firmenId = Number(this.route.snapshot.url[1].path);

    this.filterString = `includeGeloeschte eq ${this.showAlsoDeletedElements}`;

    if (!isNaN(this.firmenId)) {
      this.retrieveFirmaData();
    }
  }

  ngOnInit(): void {
    this.editStandortDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalEditStandortDaten')
    );
    this.editFirmaDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalEditFirmaDaten')
    );
    this.successModal = new window.bootstrap.Modal(
        document.getElementById('modalSuccess')
    );
    this.errorModal = new window.bootstrap.Modal(
        document.getElementById('modalError')
    );
  }

  retrieveFirmaData() {
    let resultNodeList: FirmenstandortElement[] = [];

    forkJoin({
      firma: this.firmenService.getFirmaById(this.firmenId),
      firmenstandorteData: this.firmenService.getFirmenstandorteByFirmenId(this.firmenId, this.filterString)
          .pipe(
              mergeAll(),
              mergeMap(firmenstandort => this.firmenstandorteService.getPcAdressenByFirmenstandortId(firmenstandort.id, this.filterString)
                  .pipe(
                      mergeAll(),
                      toArray(),
                  ).pipe(
                      map(
                          pcAdressen => (
                              { firmenstandort, pcAdressen }
                          )
                      ),
                  )
              ),
              toArray(),
          )
    }).subscribe(result => {
      if (result.firma) {
        this.tableFirmaDataSource = [
          {
            firmenId:             this.firmenId,
            firmenname:           result.firma.name,
            crefonummer:          result.firma.crefonummer,
            action:               ''
          }
        ]

        this.firmenElement = result.firma;
      }

      if (result.firmenstandorteData) {
        result.firmenstandorteData.forEach(firmenstandortData => {
          if (firmenstandortData.firmenstandort) {
            this.firmenStandorte.push(firmenstandortData.firmenstandort);
          }

          let resultNode: FirmenstandortElement = {
            firmenstandortId:             firmenstandortData.firmenstandort.id,
            beDirectId:                   firmenstandortData.firmenstandort.beDirectId,
            istFirmenhauptstandort:       firmenstandortData.firmenstandort.istFirmenhauptstandort,
            salesforceId:                 firmenstandortData.firmenstandort.salesforceId,
            strasseUndHausnummer:         firmenstandortData.firmenstandort.strasseUndHausnummer,
            plz:                          firmenstandortData.firmenstandort.plz,
            ort:                          firmenstandortData.firmenstandort.ort,
            telefon:                      firmenstandortData.firmenstandort.telefon,
            fax:                          firmenstandortData.firmenstandort.fax,
            email:                        firmenstandortData.firmenstandort.email,
            laendercode:                  firmenstandortData.firmenstandort.laendercode,
            istGeloescht:                 firmenstandortData.firmenstandort.istGeloescht,
            betriebsgroesse:              firmenstandortData.firmenstandort.betriebsgroesse,
            betriebsgroesseGewerblich:    firmenstandortData.firmenstandort.betriebsgroesseGewerblich,
            betriebsgroesseKaufmaennisch: firmenstandortData.firmenstandort.betriebsgroesseKaufmaennisch,
            actions:                      firmenstandortData.firmenstandort.istFirmenhauptstandort ?
              [
                {
                  label: 'Standort-Daten ändern',
                  styleClass: 'bg-gradient-primary',
                  iconClass: 'far fa-edit',
                  functionCall: this.openEditStandortDatenModal,

                },
              ] :
              [
                {
                  label: 'Standort-Daten ändern',
                  styleClass: 'bg-gradient-primary',
                  iconClass: 'far fa-edit',
                  functionCall: this.openEditStandortDatenModal,
                },
                {
                  label: 'Als Hauptstandort deklarieren',
                  styleClass: 'bg-gradient-danger',
                  iconClass: 'fas fa-exclamation',
                  functionCall: this.alsHauptstandortDeklarieren,
                },
              ],
            pcAdressen: [],
          };

          let pcAdressenList: PcAdresseElement[] = [];

          firmenstandortData.pcAdressen.forEach(pcAdresse => {
            let childNode: PcAdresseElement = {
              laendercode: "", originalFirmenname: "", ort: "", plz: "", strasseUndHausnummer: "",
              firmenId:           firmenstandortData.firmenstandort.firmenId ?? 0,
              firmenname:         result.firma.name ?? '',
              firmenstandortId:   firmenstandortData.firmenstandort.id,
              actions:            [],
              pcAdresseId:        pcAdresse.id,
              pcAdressnummer:     pcAdresse.pcAdressnummer,
              nlCode:             pcAdresse.nlCode,
              beDirectId:         firmenstandortData.firmenstandort.beDirectId ?? 0,
              canBeMoved:         !pcAdresse.istGeloescht && pcAdresse.pcAdressnummer !== firmenstandortData.firmenstandort.id
            }

            if (pcAdresse.pcAdressnummer !== pcAdresse.firmenstandorteId && pcAdresse.nlCode && pcAdresse.psDalAnschrift) {
              let firmenname = pcAdresse.psDalAnschrift.name2 ? `${pcAdresse.psDalAnschrift.name1} ${pcAdresse.psDalAnschrift.name2}` : `${pcAdresse.psDalAnschrift.name1}`
              childNode.originalFirmenname    = firmenname;
              childNode.firmenname            = firmenname;
              childNode.strasseUndHausnummer  = `${pcAdresse.psDalAnschrift.strasse} ${pcAdresse.psDalAnschrift.hausnummer}`;
              childNode.plz                   = pcAdresse.psDalAnschrift.plz?.toString();
              childNode.ort                   = pcAdresse.psDalAnschrift.ort;
              childNode.laendercode           = pcAdresse.psDalAnschrift.laendercode;

            } else {
              childNode.originalFirmenname            = pcAdresse.originalFirmenname;
              childNode.firmenname                    = pcAdresse.originalFirmenname;
              childNode.strasseUndHausnummer          = firmenstandortData.firmenstandort.strasseUndHausnummer ?? '';
              childNode.plz                           = firmenstandortData.firmenstandort.plz ?? '';
              childNode.ort                           = firmenstandortData.firmenstandort.ort ?? '';
              childNode.laendercode                   = firmenstandortData.firmenstandort.laendercode ?? 'DE';
            }
            pcAdressenList.push(childNode);
          })
          pcAdressenList.sort((a, b) => (a.nlCode) ? 1 : -1);
          resultNode.pcAdressen = pcAdressenList;
          resultNodeList.push(resultNode);
        })

        let hauptstandortNodeList: FirmenstandortElement[] = resultNodeList.filter(firmenstandort => firmenstandort.istFirmenhauptstandort);
        let andereStandorteNodeList: FirmenstandortElement[] = resultNodeList.filter(firmenstandort => !firmenstandort.istFirmenhauptstandort);

        if (andereStandorteNodeList.filter(firmenstandort => !firmenstandort.istGeloescht).length == 0) {
          hauptstandortNodeList.filter(firmenstandort => !firmenstandort.istGeloescht).forEach(firmenstandort => {
            if (firmenstandort.pcAdressen && firmenstandort.pcAdressen.length == 1) {
              firmenstandort.pcAdressen[0].canBeMoved = true;
            }
          });
        }
        this.hauptstandortDataSource = new MatTableDataSource(hauptstandortNodeList);
        this.updatePcAdresseActions(this.hauptstandortDataSource);

        andereStandorteNodeList.sort((a, b) => (a.istGeloescht) ? 1 : -1);
        andereStandorteNodeList.filter(firmenstandort => !firmenstandort.istGeloescht).forEach(firmenstandort => {
          if (firmenstandort.pcAdressen && firmenstandort.pcAdressen.length == 1 && !firmenstandort.istGeloescht) {
            if (!firmenstandort.pcAdressen[0].canBeMoved) {
              firmenstandort.pcAdressen[0].canBeMoved = true;
            }
          }
        });
        this.firmenstandortDataSource = new MatTableDataSource(andereStandorteNodeList);
        this.updatePcAdresseActions(this.firmenstandortDataSource);

        if (hauptstandortNodeList) {
          this.expandedHauptstandortElement = hauptstandortNodeList[0];
        }

        if (andereStandorteNodeList) {
          this.expandedElement = andereStandorteNodeList[0];
        }
      }
    });
  }

  updatePcAdresseActions(datasource: MatTableDataSource<FirmenstandortElement>) {
    datasource.data.forEach(node => {
      if (!node.istGeloescht) {
        node.pcAdressen?.forEach(pcAdresse => {
          if (pcAdresse.canBeMoved) {
            pcAdresse.actions.push(
              {
                label: 'PC Adresse neu zuordnen',
                styleClass: 'bg-gradient-primary',
                iconClass: 'fas fa-exchange-alt',
                functionCall: this.openDialogPcAdresseNeuZuordnen,
              },
            )
          }
        });
      }
    })
  };

  updateResultList() {
    this.showAlsoDeletedElements = !this.showAlsoDeletedElements;
    this.filterString = `includeGeloeschte eq ${this.showAlsoDeletedElements}`;
    this.retrieveFirmaData();
  }

  toggleRow(element: FirmenstandortElement) {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  toggleTransactionsRow(element: FirmenstandortElement, event: any) {
    if (element.transactions && element.transactions.length > 0) {
      element.transactions = [];
    } else {
      this.firmenstandorteService.getFirmenstandortTransactions(Number(element.firmenstandortId), 5, 0)
          .subscribe(response => {
            if (response) {
              let transactionsList: TransactionDto[] = [];
              response.forEach(transaction => {
                let transactionDto: TransactionDto = {
                  uhrzeit:        transaction.ausgefuehrtAm,
                  datum:          transaction.ausgefuehrtAm,
                  transactionId:  transaction.id,
                  aktion:         transaction.ausgefuehrteAktionen.replace(/\. /g, "\n"),
                  user:           transaction.ausgefuehrtVon,
                  kommentar:      transaction.kommentar,
                }
                transactionsList.push(transactionDto);
              });
              element.transactions = transactionsList;
            }
          });
    }
  }

  seeCompleteHistory(data: FirmenstandorteIndexResultElement) {
    return this.router.navigate([`firma/${this.firmenId}/historie/${data.firmenstandortId}`]);
  }

  toggleHauptstandortRow(element: FirmenstandortElement) {
    this.expandedHauptstandortElement = this.expandedHauptstandortElement === element ? null : element;
  }

  alsHauptstandortDeklarieren(event: Event, data: any): void {
    if (this.firmenId) {
      let newFirmehauptstandort: NewFirmenHauptstandortDto = {
        firmenstandorteId: data.firmenstandortId,
        zuletztGeaendertVon: this.userEmail,
      }
      this.firmenService.changeFirmenhauptstandort(this.firmenId, newFirmehauptstandort).subscribe(response => {
        this._snackBar.open('Hauptstandort geändert', 'Schließen', { duration: 5000 });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
    }
  }

  openDialogPcAdresseNeuZuordnen(event: Event, data: PcAdresseElement) {
    this.dialogNeuePcAdresse.open(PcAdresseNeuZuordnenComponent, {
      panelClass: 'eintrag-neu-zuordnen',
      data: {
        title:                "PC-Adresse neu zuordnen",
        selectedElementLabel: '',
        selectedElement:      `${data.strasseUndHausnummer ? data.strasseUndHausnummer + ', ' : ''} 
                              ${data.plz ? data.plz + ' ' : ''} 
                              ${data.ort ? data.ort + ' ' : ''} 
                              ${data.laendercode ? ' (' + data.laendercode + ') ' : ''}
                              ${data.beDirectId ? '- beDirect-ID ' + data.beDirectId : ''}`,
        firmenId:             data.firmenId,
        firmenstandortId:     data.firmenstandortId,
        firmenname:           data.firmenname,
        pcAdresseId:          data.pcAdresseId,
        strasseUndHausnummer: data.strasseUndHausnummer,
        plz:                  data.plz,
        ort:                  data.ort,
        laendercode:          data.laendercode,
        beDirectId:           data.beDirectId,
      }
    }).afterClosed()
      .subscribe(response => {
        if (response) {
          let pcAdresseUmhaengen: PcAdresseUmhaengenDto = {
            pcAdressenId:         data.pcAdresseId,
            zuletztGeaendertVon:  this.userEmail,
            kommentar:            response.kommentar,
          }
          if (response.startingOptionSelected == 'neue_firma') {
            pcAdresseUmhaengen.zielFirmenstandortStrasseUndHausnummer = response.neueFirmaStrasseUndHausnummer;
            pcAdresseUmhaengen.zielFirmenstandortPlz                  = response.neueFirmaPlz;
            pcAdresseUmhaengen.zielFirmenstandortOrt                  = response.neueFirmaOrt;
            pcAdresseUmhaengen.zielFirmenstandortLaendercode          = response.neueFirmaLaenderCode;
            pcAdresseUmhaengen.zielFirmenName                         = response.neueFirmaFirmenname;

            this.pcAdressenService.pcAdresseZuordnungNeueFirmaNeuerStandort(pcAdresseUmhaengen).subscribe(
                (response) => {
                  this.setAndShowSuccessMessage('PC-Adresse neue Firma neuer Standort');
                },
                (err) => {
                  this.setAndShowErrorMessage(err.error.message);
                }
            );

          } else if (response.startingOptionSelected == 'andere_firma' && response.andereFirmaOptionSelected == 'anderer_standort') {
            pcAdresseUmhaengen.zielFirmenstandorteId  = response.andereFirmaAndererFirmenstandortSelected.id;
            pcAdresseUmhaengen.zielFirmenId           = response.andereFirmaSelected.firmenId;
            pcAdresseUmhaengen.zielFirmenName         = response.andereFirmaSelected.firmenname;

            this.pcAdressenService.pcAdresseZuordnungVorhandeneFirmaVorhandenerStandort(pcAdresseUmhaengen).subscribe(
                (response) => {
                  this.setAndShowSuccessMessage('PC-Adresse andere Firma neuer Standort');
                },
                (err) => {
                  this.setAndShowErrorMessage(err.error.message);
                }
            );

          } else if (response.startingOptionSelected == 'andere_firma' && response.andereFirmaOptionSelected == 'neuer_standort') {
            pcAdresseUmhaengen.zielFirmenstandortStrasseUndHausnummer = response.neuerFirmenstandortStrasseUndHausnummer;
            pcAdresseUmhaengen.zielFirmenstandortPlz                  = response.neuerFirmenstandortPlz;
            pcAdresseUmhaengen.zielFirmenstandortOrt                  = response.neuerFirmenstandortOrt;
            pcAdresseUmhaengen.zielFirmenstandortLaendercode          = response.neuerFirmenstandortLaenderCode;
            pcAdresseUmhaengen.zielFirmenId                           = response.andereFirmaSelected.firmenId;
            pcAdresseUmhaengen.zielFirmenName                         = response.andereFirmaSelected.firmenname;

            this.pcAdressenService.pcAdresseZuordnungVorhandeneFirmaNeuerStandort(pcAdresseUmhaengen).subscribe(
                (response) => {
                  this.setAndShowSuccessMessage('PC-Adresse andere Firma anderer Standort');
                },
                (err) => {
                  this.setAndShowErrorMessage(err.error.message);
                }
            );

          } else if (response.startingOptionSelected == 'gleiche_firma' && response.gleicheFirmaOptionSelected == 'anderer_standort') {
            pcAdresseUmhaengen.zielFirmenstandorteId  = response.gleicheFirmaAndererFirmenstandortSelected.id;
            pcAdresseUmhaengen.zielFirmenId           = data.firmenId;
            pcAdresseUmhaengen.zielFirmenName         = data.firmenname;

            this.pcAdressenService.pcAdresseZuordnungVorhandeneFirmaVorhandenerStandort(pcAdresseUmhaengen).subscribe(
                (response) => {
                  this.setAndShowSuccessMessage('PC-Adresse anderer Standort');
                },
                (err) => {
                  this.setAndShowErrorMessage(err.error.message);
                }
            );

          } else if (response.startingOptionSelected == 'gleiche_firma' && response.gleicheFirmaOptionSelected == 'neuer_standort') {
            pcAdresseUmhaengen.zielFirmenstandortStrasseUndHausnummer = response.neuerFirmenstandortStrasseUndHausnummer;
            pcAdresseUmhaengen.zielFirmenstandortPlz                  = response.neuerFirmenstandortPlz;
            pcAdresseUmhaengen.zielFirmenstandortOrt                  = response.neuerFirmenstandortOrt;
            pcAdresseUmhaengen.zielFirmenstandortLaendercode          = response.neuerFirmenstandortLaenderCode;
            pcAdresseUmhaengen.zielFirmenId                           = data.firmenId;
            pcAdresseUmhaengen.zielFirmenName                         = data.firmenname;

            this.pcAdressenService.pcAdresseZuordnungVorhandeneFirmaNeuerStandort(pcAdresseUmhaengen).subscribe(
                (response) => {
                  this.setAndShowSuccessMessage('PC-Adresse neuer Standort');
                },
                (err) => {
                  this.setAndShowErrorMessage(err.error.message);
                }
            );
          }
        }
      });
  }

  openEditFirmaDatenModal(event: Event, data: any) {
    if (this.firmenElement) {
      this.editFirmaDatenForm.setValue({
        firmenname:           this.firmenElement.name                 ?? '',
        branchenzuschlag:     this.firmenElement.branchenzuschlag     ?? 'kein Branchenzuschlag',
        branchencodeWz1979:   this.firmenElement.branchencodeWz1979   ?? '',
        branchencodeWz2008:   this.firmenElement.branchencodeWz2008   ?? '',
        lieferantVonBranche:  this.firmenElement.lieferantVonBranche  ?? '0 - To be clarified',
        waehrungscode:        this.firmenElement.waehrungscode        ?? 'EUR',
        webseiteHomepage:     this.firmenElement.webseiteHomepage     ?? '',
      });
      this.editFirmaDatenModal.show();
    }
  }

  editFirmaDaten() {
    if (this.editFirmaDatenForm.status === 'VALID' && this.firmenElement && this.firmenElement.id) {
      this.firmenElement.name = this.editFirmaDatenForm.controls.firmenname.value ?? '';

      this.firmenService.patchFirma(this.firmenElement.id, this.firmenElement).subscribe(
          (response) => {
            this.setAndShowSuccessMessage('Firmendaten');
          },
          (err) => {
            this.setAndShowErrorMessage(err.error.message);
          }
      );

      this.editFirmaDatenModal.hide();
    }
  }

  closeEditFirmaDatenModal() {
    this.editFirmaDatenModal.hide();
  }

  openEditStandortDatenModal(event: Event, data: any) {
    this.currentStandortIsHauptstandort = false;
    if (data.istFirmenhauptstandort) {
      this.currentStandortIsHauptstandort = true;
    }
    this.currentStandortId = data.firmenstandortId;

    this.editStandortDatenForm.setValue({
      strasseUndHausnummer:         data.strasseUndHausnummer,
      plz:                          data.plz,
      ort:                          data.ort,
      laendercode:                  data.laendercode,
      telefon:                      data.telefon                      ?? '',
      fax:                          data.fax                          ?? '',
      email:                        data.email                        ?? '',
      betriebsgroesse:              data.betriebsgroesse              ?? 'ungeklärt',
      betriebsgroesseGewerblich:    data.betriebsgroesseGewerblich    ?? 'ungeklärt',
      betriebsgroesseKaufmaennisch: data.betriebsgroesseKaufmaennisch ?? 'ungeklärt',
    });

    this.editStandortDatenModal.show();
  }

  editStandortDaten() {
    if (this.editStandortDatenForm.status === 'VALID') {
      let firmenStandortElement: FirmenstandortDto;
      for (const firmenStandort of this.firmenStandorte) {
        if (firmenStandort.id === this.currentStandortId) {
          firmenStandortElement = firmenStandort;
          firmenStandortElement.strasseUndHausnummer         = this.editStandortDatenForm.controls.strasseUndHausnummer.value  ?? '';
          firmenStandortElement.plz                          = this.editStandortDatenForm.controls.plz.value                   ?? '';
          firmenStandortElement.ort                          = this.editStandortDatenForm.controls.ort.value                   ?? '';
          firmenStandortElement.laendercode                  = this.editStandortDatenForm.controls.laendercode.value           ?? '';

          this.firmenstandorteService.patchFirmenstandort(firmenStandortElement.id, firmenStandortElement).subscribe(
              (response) => {
                this.setAndShowSuccessMessage('Standort-Daten');
              },
              (err) => {
                this.setAndShowErrorMessage(err.error.message);
              }
          );
        }
      }
      this.editStandortDatenModal.hide();
    }
  }

  closeEditStandortDatenModal() {
    this.editStandortDatenModal.hide();
  }

  setAndShowSuccessMessage(mode: string): void {
    if (mode === 'Firmendaten') {
      this.successMsg = 'Die Firmen-Daten wurden gespeichert.';

    } else if (mode === 'Standort-Daten') {
      this.successMsg = 'Die Standort-Daten wurden gespeichert.';

    } else if (mode === 'PC-Adresse neue Firma neuer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einer neuen Firma und einem neuen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse andere Firma neuer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einer vorhandenen Firma und einem neuen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse andere Firma anderer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einer vorhandenen Firma und einem anderen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse anderer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einem anderen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse neuer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einem neuen Standort zugeordnet.';

    }

    this.successModal.show();
  }

  setAndShowErrorMessage(errorMsg: string): void {
    this.errorMsg = "Die Daten konnten nicht gespeichert werden.<br><br>Fehlermeldung: " + "<pre>" + errorMsg + "</pre>";
    this.errorModal.show();
  }

  closeSuccessModal() {
    this.successModal.hide();
    window.location.reload();
  }

  closeErrorModal() {
    this.errorModal.hide();
  }

  back() {
    this.router.navigate(['/firmen']).catch();
  }
}
